import ServicePriceRubles from '@/storage/ServicePriceRubles';
import { DISCOUNT_IN_KOPECK } from '@/components/SwitchDiscountType.vue';

/**
 * @description Пропорционально распределить абсолютную скидку между позициями.
 * @param {number}                        totalAmount Суммарная стоимость позиций.
 * @param {number}                        kop         Сумма новой скидки.
 * @param {{amount:ServicePriceRubles}[]} positions   Позиции.
 * @returns {number[]}
 */
function spreadAbsoluteDiscount(totalAmount, kop, positions) {
  let total = new ServicePriceRubles(kop);
  const discounts = positions.map((candidate) => {
    const amount = candidate.amount.toKop();
    if (amount === 0) {
      return amount;
    }
    const proportion = amount / totalAmount;
    const rub = Math.floor((proportion * kop) / 100);
    const discountAmount = new ServicePriceRubles(rub * 100);
    total = total.sub(discountAmount);
    return discountAmount.toKop();
  });
  let i = 0;
  while (total.toKop() > 0) {
    if (i === discounts.length) {
      i = 0;
    }
    const remainder = positions[i].amount.toKop() - discounts[i];
    if (remainder > 0) {
      const amount = Math.min(total.toKop(), 100, remainder);
      discounts[i] += amount;
      total = total.sub(new ServicePriceRubles(amount));
    }
    i += 1;
  }
  return discounts;
}

/**
 * @description Распределить процентную скидку между позициями.
 * @param {number} percent
 * @param {Array}  positions
 * @returns {number[]}
 */
function spreadPercentDiscount(percent, positions) {
  return positions.map(() => percent);
}

/**
 * @description Примесь распределения скидки.
 * @type {Vue}
 */
export default {
  methods: {
    /**
     * @description Распределить скидку.
     * @param {string}                        discountType Тип скидки.
     * @param {number}                        value        Значение скидки.
     * @param {{amount:ServicePriceRubles}[]} positions    Позиции.
     * @param {number}                        totalAmount  Суммарная стоимость позиций.
     * @returns {number[]}
     */
    spreadDiscount(discountType, value, positions, totalAmount) {
      if (discountType === DISCOUNT_IN_KOPECK) {
        return spreadAbsoluteDiscount(totalAmount, value, positions);
      }
      return spreadPercentDiscount(value, positions);
    },
  },
};
